<template>

  <div class="evaluate-box">
    <!--订单商品信息-->
    <goodscell class="goodsCell" :info="orederInfo" :isShowBtn="false"></goodscell>
    <div class="text-left">评价：
      <van-rate v-model="submitData.star" @change="rateChange" />
      <span class="rate-text"> {{rateText}}</span>
    </div>
    <van-field v-model="submitData.content" rows="2" autosize type="textarea" maxlength="100" placeholder="请输入评价" show-word-limit />
    <div class="limit">上传图片(最多9张)</div>
    <van-uploader @delete="deleteEvent" v-model="fileList" :maxCount="9" multiple />
    <div class="submit-btn">
      <van-button type="primary" class="sub-btn" @click="onSubmit" size="large">提交</van-button>
    </div>
  </div>
</template>



<script>
import { orderGoods, batchUpload, orderComment } from "@/api/index";
import goodscell from "../../components/goodscell";
import { Toast, Dialog } from "vant";

export default {
  name: "evaluate",
  data() {
    return {
      orederInfo: {},
      fileList: [],
      submitData: {
        orderGoodsId: 132, //订单中商品id
        content: "", //评论内容
        star: 0, //星数
        hasPicture: false,
        picUrls: [], //图片
      },
      rateText: "",
      hasPicList: false,
      picUrlList: [],
    };
  },
  components: { goodscell },

  mounted() {
    console.log(this.$route.query);
    let data = {
      orderGoodsId: this.$route.query.orderGoodsId,
    };
    orderGoods(data).then((res) => {
      console.log(res);
      if (res.data.errno == 0) {
        this.orederInfo = res.data.data;
      } else {
        Dialog.alert({
          title: "提示",
          message: res.data.errmsg,
        });
      }
    });
  },
  methods: {
    rateChange(rate) {
      console.log(rate);
      switch (rate) {
        case 1:
          this.rateText = "很差";
          break;
        case 2:
          this.rateText = "不太满意";

          break;
        case 3:
          this.rateText = "满意";

          break;
        case 4:
          this.rateText = "比较满意";

          break;
        default:
          this.rateText = "十分满意";

          break;
      }
    },
    deleteEvent(file, idx) {
      console.log(idx.index);
      this.submitData.picUrls.splice(idx.index, 1);
    },

    onSubmit() {
      if (this.submitData.star == 0) {
        Toast("请对评价进行打分");
        return;
      }
      console.log(this.submitData.length);
      if (
        this.submitData.content == "" &&
        this.submitData.content.length == undefined
      ) {
        Toast("内容不能为空");
        return;
      }

      if (this.fileList.length > 0) {
        var param = new FormData(); // FormData 对象
        this.fileList.forEach((item) => {
          console.log(item);
          param.append("files", item.file); // 文件对象
        });

        batchUpload(param).then((res) => {
          if (res.data.errno == 413) {
            Dialog.alert({
              title: "提示",
              message: "图片过大，请重新选择上传",
            });
          }

          if (res.data.errno != 0) return;
          console.log(res);
          this.submitData.picUrls = res.data.data;
          this.submitData.orderGoodsId = this.orederInfo.id;
          this.submitData.hasPicture = true;
          console.log(this.submitData);
          orderComment(this.submitData).then((res) => {
            console.log(res);
            if (res.data.errno == 0) {
              this.$router.go(-1);
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.errmsg,
              }).then(() => {
                // on close
              });
            }
          });
        });

        // });
      } else {
        this.submitData.orderGoodsId = this.orederInfo.id;

        this.submitData.hasPicture = false;
        orderComment(this.submitData).then((res) => {
          console.log(res);
          if (res.data.errno == 0) {
            Toast("评价成功");
            sessionStorage.setItem("hasEvaluate", true);
            this.$router.go(-1);
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.errmsg,
            });
          }
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.evaluate-box {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  padding-bottom: 8.8rem;
  .goodsCell {
    background-color: white;
    margin: 1rem auto;
  }
  .text-left {
    text-align: left;
    padding-left: 1rem;
    height: 3rem;
    display: flex;
    align-items: center;
  }
  .limit {
    height: 3rem;
    line-height: 3rem;
    text-align: left;
    padding-left: 1rem;
    box-sizing: border-box;
  }
  .submit-btn {
    width: 100%;
    margin: 1rem auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    background: #fff;
    height: 8.8rem;
    position: fixed;
    padding-top: 0.8rem;
    box-sizing: border-box;
    bottom: 0;
    .sub-btn {
      background: #d6be93;
      border-radius: 24px;
      height: 4rem;
      width: 89.3%;
      font-family: PingFangSC-Regular;
      font-size: 1.6rem;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 4rem;
      border: 0;
    }
  }
  .rate-text {
    opacity: 0.5;
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #424242;
    letter-spacing: 0;
    line-height: 1.2rem;
    margin-left: 1rem;
  }
  /deep/ .van-uploader {
    width: 100%;
    padding-left: 1rem;
    box-sizing: border-box;
  }
  /deep/ .van-cell {
    border: 1px solid #eee;
    width: 95%;
    padding: 5px 5px;
    margin: 1rem auto;
  }
  /deep/ .van-field__label {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/person/evaluate.vue